<template>
	<fixed-header :fixed.sync="isFixed" :threshold="650">
		<div
			class="menu__block menu"
			:class="{ fixed: isFixed }"
			style="float: left; width: 100%"
		>
			<slot name="mobile_menu"> </slot>
			<menu id="navigation1" class="navigation">
				<ul>
					<li v-for="(menuItem, index) in menuItems" class="menuItem" :key="index">
						<menu-item :menuItem="menuItem" class="menu__item"></menu-item>
					</li>
				</ul>
			</menu>
		</div>
	</fixed-header>
</template>

<script>
import MenuItem from './MenuItem';
import FixedHeader from 'vue-fixed-header';

export default {
	name: 'BaseMenu',
	components: { MenuItem, FixedHeader },
	props: {
		menuItems: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			isFixed: false
		}
	}
}
</script>

<style scoped></style>
